import React from 'react';
import { string } from 'prop-types';
import classname from 'classnames/bind';
import { Col, Heading, Row } from '@thd-olt-component-react/core-ui';
import styles from './CarouselHeader.module.scss';

const cx = classname.bind(styles);

const CarouselHeader = ({ title, subtitle }) => (
  <Row className={cx('container-title')}>
    <Heading title={title} underline />
    {
      subtitle
      && (
        <Row>
          <h4> {subtitle} </h4>
        </Row>
      )
    }
  </Row>
);

CarouselHeader.propTypes = {
  title: string,
  subtitle: string,
};

CarouselHeader.defaultProps = {
  title: '',
  subtitle: null,
};

export { CarouselHeader };